<template>

    <div class="block block-rounded" :style="blockStyle" :class="{ 'mb-0': removeMargin }">

        <div v-if="title || $slots.title || $slots.options" class="block-header block-header-default">
            <h3 class="block-title">
                <span v-if="title">
                    {{ title }}
                </span>
                <span v-else-if="$slots.title">
                    <slot name="title"></slot>
                </span>
            </h3>
            <div class="block-options">
                <slot name="options"></slot>
            </div>
        </div>

        <div v-if="heading" class="block-content block-content-full block-content-heading" :class="{'p-2': slim === true}">
            {{ heading }}
        </div>
        <template v-else-if="$slots.heading">
            <div class="block-content block-content-full block-content-heading" :class="{'p-2': slim === true}">
                <slot name="heading"></slot>
            </div>
        </template>

        <div class="block-content block-content-full" :class="{'p-0': slim === true}">
            <slot></slot>
        </div>

        <div v-if="$slots.footer" class="bg-body-light rounded-bottom">
            <div class="block-content block-content-full block-content-sm">
                <slot name="footer"></slot>
            </div>
        </div>

    </div>

</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                required: false,
                default: null,
            },
            options: {
                type: Object,
                required: false,
                default: null,
            },
            heading: {
                type: String,
                required: false,
                default: null,
            },
            backgroundColor: {
                type: String,
                required: false,
                default: null,
            },
            removeMargin: {
                type: Boolean,
                required: false,
                default: false,
            },
            slim: {
                type: Boolean,
                required: false,
                default: false,
            }
        },
        computed: {
            blockStyle() {
                return this.backgroundColor ? { backgroundColor: this.backgroundColor } : {}
            }
        }
    }
</script>
